import * as React from 'react';
import { TAppNavigation } from './index.types';
import { Route, Routes, useNavigate } from 'react-router';
import { NotFoundFallback } from './ErrorScreens/NotFoundFallback/NotFoundFallback';
import { HomePage } from './HomePage/HomePage';
import { ProductPage } from './ProductPage/ProductPage';
import { APP_ROUTES } from '../constants/routes';
import { PhoneCasesList } from './Products/PhoneCases/PhoneCasesList';
import { AdminPanel } from './AdminPanel/AdminPanel';
import { PhoneCaseBuilder, iphone14ProMaxTemplate } from 'components';
import { Checkout } from './Checkout/Checkout';
import { useNotificationsHandler } from 'hooks/useNotificationsHandler';
import { navigationRef } from 'hooks/useNavigationRef';
import { AdminRoute, UnauthRoute } from 'helpers';
import { VerifyEmail } from './VerifyEmail/VerifyEmail';
import { RequestResetPassword } from './RequestResetPassword/RequestResetPassword';
import { ResetPassword } from './ResetPassword/ResetPassword';

export const AppNavigation: TAppNavigation = () => {
  const navigation = useNavigate();
  useNotificationsHandler();

  React.useEffect(() => {
    navigationRef.current = navigation;
  }, [navigation]);

  return (
    <Routes>
      {/* Public routes */}
      <Route path={APP_ROUTES.HOME} element={<HomePage />} />
      <Route path={APP_ROUTES.PHONE_CASE_PRODUCT} element={<ProductPage />} />
      <Route path={APP_ROUTES.PHONE_CASES} element={<PhoneCasesList />} />
      <Route
        path={APP_ROUTES.BUILDER}
        element={<PhoneCaseBuilder template={iphone14ProMaxTemplate} />}
      />
      <Route path={APP_ROUTES.CHECKOUT} element={<Checkout />} />

      {/* ADNMIN */}
      <Route
        path={APP_ROUTES.ADMIN_PANEL}
        element={
          <AdminRoute>
            <AdminPanel />
          </AdminRoute>
        }
      />
      {/*Anauth routes*/}

      <Route
        path={APP_ROUTES.VERIFY_EMAIL}
        element={
          <UnauthRoute>
            <VerifyEmail />
          </UnauthRoute>
        }
      />
      <Route
        path={APP_ROUTES.REQUEST_RESET_PASSWORD}
        element={
          <UnauthRoute>
            <RequestResetPassword />
          </UnauthRoute>
        }
      />

      <Route
        path={APP_ROUTES.RESET_PASSWORD}
        element={
          <UnauthRoute>
            <ResetPassword />
          </UnauthRoute>
        }
      />

      <Route path={APP_ROUTES.INVALID_PATH} element={<NotFoundFallback />} />
    </Routes>
  );
};
